import api from "../api"
export default {
	async changePassword(user, oldpassword, newpassword, confirmpassword) {
		let value = await api.put(`/users/${user}/password`, {oldpassword, newpassword, confirmpassword})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
 
		let data = value.data.data
		return data
	},
	async updateUser(user, email, firstname, lastname, enableEmailNotifications) {
		let value = await api.patch(`/users/${user}`, {email, firstname, lastname, enableEmailNotifications})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
 
		let data = value.data.data
		return data
	},
	async getRoles(user) {
		let value = await api.get(`/users/${user}/roles`)
		if (value.data.error.length > 0) {
			throw new Error(value.data.error[0].message)
		}
		let data = value.data.data
		return {
			items: data,
			total: value.data.metadata.pagination.totalRecords
		}
	},
	async addRoles(user, roles) {
		let value = await api.post(`/users/${user}/roles`, { roles: roles })
		if (value.data.error.length > 0) {
			throw new Error(value.data.error[0].message)
		}
	},
	async removeRole( user, role ) {
		let value = await api.delete(`/users/${user}/roles/${role}`)
		if (value.data.error.length > 0) {
			throw new Error(value.data.error[0].message)
		}
	},
	async getUser(user) {
		let value = await api.get(`/users/${user}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message) 
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},
	async getUsers() {
		let value = await api.get(`/users`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},
	async getOnsiteUsers() {
		let value = await api.get(`/onsiteusers`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		let data = value.data.data
		return data
	},
	/**
	 * Adds a new user
	 * @param {string} email
	 * @param {string} password
	 */
	async addUser(firstname, lastname, email, password) {
		var value = await api.post(`/users`, {
			firstname,
			lastname,
			email,
			password
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async deleteUser(user) {
		let value = await api.delete(`/users/${user}`)
		if (value.data.error.length > 0) {
			throw new Error(value.data.error[0].message)
		}
	},

	async getCompanyMembers(clientID) {
		let value = await api.get(`/company-users/`, {
			params: { clientID: clientID },
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},
}
